import { createSlice } from '@reduxjs/toolkit';
import {
  getFormFields,
  saveFormFields,
  deleteFormField,
} from './actions'; 

const createResourceState = () => ({
  data: [],
  selected: null,
  pagination: null,
  isLoading: false,
  isMutating: false,
  error: null,
});

const initialState = {
  formFields: createResourceState(),
  error: null,
};

const unwrapList = (payload) => {
  if (Array.isArray(payload)) return { data: payload, pagination: null };
  const body = payload?.data ?? payload;
  if (Array.isArray(body)) {
    return { data: body, pagination: payload?.pagination ?? null };
  }
  return {
    data: body?.results ?? body?.items ?? [],
    pagination: body?.pagination ?? payload?.pagination ?? null,
  };
};

const errorMessage = (action) =>
  action.payload?.message ?? action.error?.message ?? 'Something went wrong';

const complaintSlice = createSlice({
  name: 'complaintAppComplaint',
  initialState,
  reducers: {
    clearComplaintError(state, action) {
      const resource = action.payload;
      if (resource && state[resource]?.error !== undefined) {
        state[resource].error = null;
      } else {
        state.error = null;
      }
    },
    clearSelectedComplaintResource(state, action) {
      const resource = action.payload;
      if (resource && state[resource]?.selected !== undefined) {
        state[resource].selected = null;
      }
    },
    resetComplaintState() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    
    builder
      .addCase(getFormFields.pending, (state) => {
        state.formFields.isLoading = true;
        state.formFields.error = null;
      })
      .addCase(getFormFields.fulfilled, (state, action) => {
        const result = unwrapList(action.payload);
        state.formFields.isLoading = false;
        state.formFields.data = result.data;
      })
      .addCase(getFormFields.rejected, (state, action) => {
        state.formFields.isLoading = false;
        state.formFields.error = errorMessage(action);
      })
      .addCase(saveFormFields.pending, (state) => {
        state.formFields.isMutating = true;
        state.formFields.error = null;
      })
      .addCase(saveFormFields.fulfilled, (state) => {
        state.formFields.isMutating = false;
      })
      .addCase(saveFormFields.rejected, (state, action) => {
        state.formFields.isMutating = false;
        state.formFields.error = errorMessage(action);
      })
      .addCase(deleteFormField.pending, (state) => {
        state.formFields.isMutating = true;
        state.formFields.error = null;
      })
      .addCase(deleteFormField.fulfilled, (state, action) => {
        const deletedId = action.meta.arg?.fieldId;
        state.formFields.isMutating = false;
        state.formFields.data = state.formFields.data.filter((field) => field.id !== deletedId);
      })
      .addCase(deleteFormField.rejected, (state, action) => {
        state.formFields.isMutating = false;
        state.formFields.error = errorMessage(action);
      });
      
  },
});

export const {
  clearComplaintError,
  clearSelectedComplaintResource,
  resetComplaintState,
} = complaintSlice.actions;

export default complaintSlice.reducer;
